export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_STOCK_MANAGEMENT_STATUS = 'UPDATE_STOCK_MANAGEMENT_STATUS';
export const RECEIVE_UBEREATS_CLIENT_ID = 'RECEIVE_UBEREATS_CLIENT_ID';
export const UPDATE_PARTNER_STOCK_MANAGEMENT_STATUS =
	'UPDATE_PARTNER_STOCK_MANAGEMENT_STATUS';
export const RECEIVE_USER = 'RECEIVE_USER';
